<a class="nav-link" (click)="viewReport()" id="nav-print-report">
  <div class="icon-container">
    <img src="/assets/images/menu/ICN_Line_Print.svg"/>
  </div>
  View/Print Credit Report
</a>
<hr />
